export default __webpack_public_path__ + "static/media/instagram.b0c484b3.svg";